import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { useAllowAssetDeleteWithActiveContractsToggle } from '../../../../../configuration/featureToggle/toggleHooks';
import { useIsLatamTenant, useIsTestTenant } from '../../../../../configuration/login/loginSlice';
import { useGetActiveContractsQuery } from '../../../../services/contractsApi';
import { useCheckActiveContractsQuery } from '../../../../services/latamContractsApi';

interface ActiveContractsWarningProps {
    assetId: string;
    deletionMode: boolean;
}

export const ActiveContractsWarning = ({ assetId, deletionMode }: ActiveContractsWarningProps) => {
    const isLatamTenant = useIsLatamTenant();
    const { data: activeContracts } = useGetActiveContractsQuery(assetId, { skip: isLatamTenant });
    const { data: activeLatamContracts } = useCheckActiveContractsQuery(assetId, { skip: !isLatamTenant });
    const allowAssetDeleteWithActiveContracts = useAllowAssetDeleteWithActiveContractsToggle();
    const isTestTenant = useIsTestTenant();

    if (!(activeContracts?.length || activeLatamContracts?.length)) {
        return null;
    }

    return (
        <div className='alert alert-danger display-flex flex-column gap-15 margin-top-10'>
            <div className='display-flex gap-10'>
                <span className={'text-color-danger text-size-h4 rioglyph rioglyph-error-sign'} />
                <div>
                    <strong className='text-size-16'>
                        {deletionMode && !allowAssetDeleteWithActiveContracts && !isTestTenant ? (
                            <FormattedMessage
                                id={'assets.assets.asset.delete-confirmation-dialog.content.active-contracts.title'}
                            />
                        ) : (
                            <FormattedMessage
                                id={'assets.assets.asset.archive-confirmation-dialog.content.active-contracts.title'}
                            />
                        )}
                    </strong>
                    <div>
                        {deletionMode ? (
                            <FormattedMessage
                                id={'assets.assets.asset.delete-confirmation-dialog.content.active-contracts.hint'}
                            />
                        ) : (
                            <FormattedMessage
                                id={'assets.assets.asset.archive-confirmation-dialog.content.active-contracts.hint'}
                            />
                        )}
                        <div className='panel panel-default panel-body margin-y-10'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <td className='padding-0 padding-bottom-5 text-bold'>
                                            <FormattedMessage
                                                id={
                                                    'assets.assets.asset.delete-confirmation-dialog.content.active-contracts.service'
                                                }
                                            />
                                        </td>
                                        {isLatamTenant ? (
                                            ''
                                        ) : (
                                            <td className='padding-0 padding-bottom-5 text-bold'>
                                                <FormattedMessage
                                                    id={
                                                        'assets.assets.asset.delete-confirmation-dialog.content.active-contracts.end-date'
                                                    }
                                                />
                                            </td>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {activeContracts?.map(({ product_level_name, ends_at }) => (
                                        <tr className='bg-none' key={product_level_name}>
                                            <td className='padding-0 border-none'>{product_level_name}</td>
                                            <td className='padding-0 border-none'>{moment(ends_at).format('D.M.Y')}</td>
                                        </tr>
                                    ))}
                                    {activeLatamContracts?.map(
                                        ({ product_name, subscription_id, period_description }) => (
                                            <tr className='bg-none' key={subscription_id}>
                                                <td className='padding-0 border-none'>
                                                    {product_name} {period_description}
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'right' }}>
                            <button
                                onClick={() =>
                                    window.open(
                                        encodeURI(
                                            `https://contact-form.rio.cloud/contact?opener=${deletionMode ? 'delete' : 'archive'} asset ${assetId}`
                                        ),
                                        '_blank'
                                    )
                                }
                                type='button'
                                className='btn btn-primary'
                            >
                                <FormattedMessage
                                    id={`assets.assets.asset.${deletionMode ? 'delete' : 'archive'}-confirmation-dialog.button.contact-support`}
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
